import googleMapsApiKey from "@lib-shared/config/google-maps-api-key";
import { localEnvironment, utilityServiceUrl } from "../../../../libs/menu-shared/src/environments/default-menu.config";

const environment = {
  production: true,
  disableAnalytics: false,
  urls: {
    installersApi: `${utilityServiceUrl}/uni-api/installersanddealers-unifiedapi/api`
  },
  map: {
    apiKey: googleMapsApiKey,
    mapId: "DEMO_MAP_ID",
    defaultCenter: {
      lat: -26.2041,
      lng: 28.0473
    },
    defaultZoom: 12
  },
  defaultCountryCode: "ng",
  menu: localEnvironment
};

export default environment;
